import {React, useEffect, useState} from 'react';
import { Navigation } from './commons/navigation.tsx';
import ToolsContent from './commons/tools-content-general.tsx';
import { Notifications } from './commons/notifications.tsx';
import {
  AppLayout,
  BreadcrumbGroup,
  Container,
  ContentLayout,
  Flashbar,
  Header,
  HelpPanel,
  Cards,
  Box,
  Button,
  SpaceBetween,
  Link,
  SideNavigation,
  SplitPanel,
} from '@cloudscape-design/components';

const CardsView = () => (
    <Cards
    ariaLabels={{
      itemSelectionLabel: (e, t) => `select ${t.name}`,
      selectionGroupLabel: "Item selection",
    }}
    
    cardDefinition={{
      header: (item) => (
        <Link href={item.sourceLink} fontSize="heading-m">
          {item.title}
        </Link>
      ),
      sections: [
        {
          id: "description",
          header: "",
          content: (item) => (
            <div>     
              <p>{item.description}</p>
              <p>{item.extraDescription}</p>
            </div>
          ),
        },
      ],
    }}
    cardsPerRow={[
      { cards: 1 },
      { minWidth: 500, cards: 2 },
    ]}
    items={[
      {
        title: "Water could be the key to finding life",
        alt: "First",
        description: "Water is essential for life and makes up about 60% of the human body.",
        extraDescription: "There aren’t many qualities that are true of all life on Earth, but the need for water is one of them. Water made life possible on Earth. Because of this, astrobiologists (scientists who search for life on other planets) think our best bet for finding life is to search for water. ",
        sourceLink: "https://climatekids.nasa.gov/10-things-water/",
      },
      {
        title: "Water Coverage on Earth",
        alt: "Second",
        description: "Water covers about 71% of the Earth's surface.",
        extraDescription: "This includes oceans, seas, lakes, rivers, and other water bodies. Only a small fraction of this water is freshwater that is suitable for human consumption and use.",
        sourceLink: "https://climatekids.nasa.gov/10-things-water/",
      },
      {
        title: "Water Consumption in the US",
        alt: "Third",
        description: "The average person in the United States uses about 80-100 gallons of water per day.",
        extraDescription: "This includes water used for household activities, such as showering, washing dishes, and watering lawns, as well as industrial and agricultural uses.",
        sourceLink: "https://www.epa.gov/watersense/statistics-and-facts",
      },
      {
        title: "Global Water Scarcity",
        alt: "Fourth",
        description: "About 4 billion people, representing nearly two-thirds of the global population, experience severe water scarcity during at least one month of the year.",
        extraDescription: "This is a significant challenge that requires sustainable water management and conservation efforts to ensure access to clean water for all.",
        sourceLink: "https://advances.sciencemag.org/content/2/2/e1500323/tab-figures-data",
      },
      {
        title: "AWS Water Positive Commitment",
        alt: "Fifth",
        description: "AWS is committed to being water positive by 2030 and making more water available to the communities where we operate.",
        extraDescription: "This commitment includes initiatives to improve water use efficiency, increase water recycling and reuse, and support water replenishment projects in local communities.",
        sourceLink: "https://sustainability.aboutamazon.com/natural-resources/water",
      },
      {
        title: "AWS Data Center Water Efficiency",
        alt: "Sixth",
        description: "AWS data centers have a water use efficiency of 0.19 liters per kilowatt-hour.",
        extraDescription: "This efficient water usage is achieved through innovative cooling technologies and water recycling and reuse practices.",
        sourceLink: "https://sustainability.aboutamazon.com/natural-resources/water",
      },
      {
        title: "Recycled Water for Irrigation",
        alt: "Seventh",
        description: "96% of spent cooling water in Oregon is made available to farmers for use in the irrigation of crops.",
        extraDescription: "This helps to conserve freshwater resources and support sustainable agriculture in the region.",
        sourceLink: "https://sustainability.aboutamazon.com/natural-resources/water",
      },
      {
        title: "AWS Global Water Recycling",
        alt: "Eighth",
        description: "20 AWS data centers across the globe are using recycled water for cooling.",
        extraDescription: "This helps to reduce the demand for freshwater and promote water conservation in the communities where AWS operates.",
        sourceLink: "https://sustainability.aboutamazon.com/natural-resources/water",
      },
      {
        title: "AWS Water Replenishment Projects",
        alt: "Ninth",
        description: "2.4 billion liters of water are returned to communities each year from replenishment projects completed or underway.",
        extraDescription: "These projects help to restore water balances and support the local communities' access to clean water.",
        sourceLink: "https://sustainability.aboutamazon.com/natural-resources/water",
      },
    ]}
      header={
          <Header 
              variant="h2"
              description = "Did you know these?"
              >
              Learn about interesting sustainability facts!
          </Header>
      }
    />
  );

export default function () {
    const [toolsOpen, setToolsOpen] = useState(true);
    const [navOpen, setNavOpen] = useState(true); 
  
    return (
        <AppLayout
          breadcrumbs={
            <BreadcrumbGroup
              items={[
                { text: 'Plantly', href: '#' },
                { text: 'Facts', href: '#' },
              ]}
            />
          }
          navOpen={navOpen}
          onNavChange={({ detail }) => setNavOpen(detail.open)}
          navigation={<Navigation activeHref="/facts" />}
          notifications={<Notifications />}
          toolsOpen={toolsOpen}
          onToolsChange={({ detail }) => setToolsOpen(detail.open)}
          tools={ToolsContent}
          content={
            <ContentLayout header={<Header variant="h1">Facts</Header>}>
                <SpaceBetween size="s">
                <CardsView />
                </SpaceBetween>
            </ContentLayout>
          }
        />
    );
  }





